import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import OfferPagePropertyTitle from '../OfferPagePropertyTitle'
import { getShareModalConfig } from 'lib/customer/getShareModalConfig'
import BodyText from 'components/Luxkit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import OfferPageLabelGroup from '../OfferPageLabelGroup'
import OfferRating from 'components/Common/NumberRating/OfferRating'
import { isOfferRatingDisplayable } from 'lib/order/reviewUtils'
import LoyaltyRoomUpgradeBenefitLabel from 'loyalty/components/LoyaltyRoomUpgradeBenefitLabel'
import useLoyaltyUserBenefit from 'loyalty/hooks/useLoyaltyUserBenefit'

const PropertyLogo = styled(Image)`
  display: none;

  ${mediaQueryUp.desktop} {
    margin-left: ${rem(16)};
    display: block;
    height: ${rem(75)};
  }
`

interface Props {
  offer: App.HotelOffer;
  property: App.OfferProperty;
  shareModalConfig: ReturnType<typeof getShareModalConfig>;
}

function FlashHotelPropertyDetails(props: Props) {
  const {
    offer,
    property,
  } = props

  const location = [offer.locationHeading, offer.locationSubheading].filter(t => t).join(', ')
  const loyaltyRoomUpgradeBenefitDetails = useLoyaltyUserBenefit('hotel_upgrade')
  const hasRoomUpgradesAvailable = !!loyaltyRoomUpgradeBenefitDetails?.remaining

  return (
    <Group direction="vertical" gap={8} tabletGap={20}>
      <Group direction="vertical" desktopDirection="horizontal" desktopHorizontalAlign="space-between" desktopVerticalAlign="center" >
        <Group direction="vertical" gap={8}>
          <BodyTextBlock data-testid="offer-location" variant="small" startIcon={<LineMapMarkerIcon />}>
            {location}
          </BodyTextBlock>
          <OfferPagePropertyTitle propertyName={property.name} />
          <CSSBreakpoint max="mobile">
            <Group direction="vertical" gap={8}>
              {isOfferRatingDisplayable(property.rating) && <OfferRating
                link
                inlineLabel
                variant="xs"
                rating={property.rating}
              />}
              <OfferPageLabelGroup offer={offer} showViewsLabel showBadge/>
            </Group>
          </CSSBreakpoint>
          <BodyText variant="medium">{offer.name}</BodyText>
        </Group>
        {property.logoImageId &&
          <PropertyLogo
            dpr={2}
            height={75}
            enhancedFormats={false}
            id={property.logoImageId}
            alt={`${property.name || 'Vendor'} logo`}
          />}
      </Group>
      {isOfferRatingDisplayable(property.rating) && <CSSBreakpoint min="tablet">
        <OfferRating
          link
          inlineLabel
          variant="small"
          rating={property.rating}
        />
      </CSSBreakpoint>}
      {offer.loyalty.hasUpgradablePackages && hasRoomUpgradesAvailable && <LoyaltyRoomUpgradeBenefitLabel />}
    </Group>
  )
}

export default FlashHotelPropertyDetails
